
// Modal Backdrop
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  [data-theme='dark'] & {
    background: rgba(0, 0, 0, 0.7);
  }
}

// Modal Container
.modal {
  width: 100%;
  max-width: 800px;
  background: var(--color-surface-primary);
  border-radius: map.get($radius, 'lg');
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
}

// Header
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-bottom: 1px solid var(--color-grey-soft);
}

.title {
  @include heading-4;
  margin: 0;
  color: var(--color-text-primary);
}

.closeButton {
  flex-shrink: 0;
}

// Content
.content {
  flex: 1;
  overflow-y: auto;
  padding: map.get($spacing-scale, 'xl');
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'xl');
}

// Section
.section {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'md');
}

.sectionTitle {
  @include body-bold;
  margin: 0;
  color: var(--color-text-primary);
}

.optional {
  @include body-regular;
  color: var(--color-text-tertiary);
  font-weight: 400;
}

// Items
.items {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'md');
}

// Editable Input - overrides for Input component
.editableInput {
  background-color: var(--color-surface-primary);
  border: 1px solid var(--color-grey-neutral);

  &:focus-within {
    border-color: var(--color-primary-base);
  }
}

// Sequence section — outside scrollable content
.sequenceSection {
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-top: 1px solid var(--color-grey-soft);
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'md');
}

.sequenceDropdownWrapper {
  position: relative;
}

.sequenceTrigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: map.get($spacing-scale, 'sm');
  width: 100%;
  height: 52px;
  padding: 0 map.get($spacing-scale, 'md');
  background: var(--color-surface-primary);
  border: 1px solid var(--color-grey-neutral);
  border-radius: map.get($radius, 'md');
  cursor: pointer;
  @include body-regular;
  @include transition(border-color);

  &:hover {
    border-color: var(--color-grey-dark);
  }
}

.sequenceTriggerOpen {
  border-color: var(--color-primary-base);
}

.sequencePlaceholder {
  flex: 1;
  text-align: left;
  color: var(--color-text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sequenceValue {
  flex: 1;
  text-align: left;
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sequenceArrow {
  flex-shrink: 0;
  color: var(--color-text-tertiary);
}

.sequenceDropdown {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 100;
}

// Footer
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-top: 1px solid var(--color-grey-soft);
}

// Responsive adjustments
@media (max-width: $breakpoint-md) {
  .modal {
    max-width: 100%;
    margin: 0;
    border-radius: map.get($radius, 'md');
  }

  .header {
    padding: map.get($spacing-scale, 'md');
  }

  .content {
    padding: map.get($spacing-scale, 'md');
  }

  .sequenceSection {
    padding: map.get($spacing-scale, 'md');
  }

  .footer {
    padding: map.get($spacing-scale, 'md');
  }
}
